/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Agenda_AddInputs */



/**
* | output |
* | --- |
* | "Add to my agenda" |
*
* @param {Tournaments_Agenda_AddInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_agenda_add = /** @type {((inputs?: Tournaments_Agenda_AddInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Agenda_AddInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter à mon agenda")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir a mi agenda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Adicionar à minha agenda")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi alla mia agenda")
	return /** @type {LocalizedString} */ ("Add to my agenda")
});